import React, { useContext } from 'react';
import UserContext from '../../context/UserContext.js';
import * as ModoEdicion from '../constantes/ModoEdicion.js';
import { TipoConversion } from '../constantes/Parametros';
import { NombreApellidoGol } from '../funciones/FuncionesPersona.js';
import BotonEdicion from '../UI/botones/BotonEdicion';
import styles from './DetalleGolesEquipo.module.css';

const DetalleGolesEquipo = (props) => {
  const equipo = props.equipo;
  const goles = props.goles;
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  const onClickHandler = (event) => {
    if (puedeEditar) {
      props.onClickEditarGol(event);
    }
  };

  let golesEquipo = [];
  if (goles && goles.length > 0) {
    golesEquipo = goles.filter((gol) => gol.equipo.id === equipo.id);
  }

  console.log('DetalleGolesEquipo', { equipo, goles });

  return (
    <React.Fragment>
      {golesEquipo &&
        golesEquipo.map(
          (gol, index) =>
            ((gol.equipo.id === equipo.id &&
              (!gol.tipoCoversion || !gol.tipoConversion.enContra)) ||
              (gol.equipo.id !== equipo.id &&
                gol.tipoCoversion &&
                gol.tipoConversion.enContra)) && (
              <div key={index} className={`${styles.detalleGol}`}>
                <React.Fragment>
                  <div className={`${styles.tiempoGol}`}>
                    {gol.tiempo ? gol.tiempo + ': ' + (gol.minutos && gol.minutos + "'") : ''}
                  </div>
                  <div className={`${styles.autorGol}`}>
                    <React.Fragment>
                      {NombreApellidoGol(gol) +
                        (gol.tipoConversion &&
                        gol.tipoConversion.codigo !== TipoConversion.SIN_CLASIFICAR.codigo
                          ? ' (' + gol.tipoConversion.descripcion.toLowerCase() + ')'
                          : '')}
                    </React.Fragment>
                  </div>
                  {puedeEditar && (
                    <div className={`${styles.editarGol}`}>
                      <BotonEdicion
                        id={gol.id}
                        modo={ModoEdicion.EDITAR}
                        onClick={onClickHandler}
                      />
                    </div>
                  )}
                </React.Fragment>
              </div>
            )
        )}
      {!golesEquipo || golesEquipo.length === 0 ? (
        <div className={`${styles.sinGoles}`}>No hubo</div>
      ) : null}
    </React.Fragment>
  );
};

export default DetalleGolesEquipo;
